import { Navigate, useParams } from "react-router-dom";
import { AuthContext } from "../../contexts/AuthContext";
import { useContext } from "react";

const ProtectedRouteWithManagerCheck = ({ children }) => {
    const { manager_id } = useParams();
    const { user } = useContext(AuthContext);

    const actualManagerId = user ? user.user_id : null;

    if (!actualManagerId) {
        return <Navigate to="/unauthorized" replace />;
    }

    if (parseInt(manager_id) !== actualManagerId) {
        return <Navigate to="/unauthorized" replace />;
    }

    return children;
};

export default ProtectedRouteWithManagerCheck;
